module.exports = __webpack_public_path__ + "img/error-submit-1.420619f.png";